/**
 * A worker's clinical credential. Distinct from `SessionRole` in
 * api/client.ts, which is who is signed in (operator vs facility
 * administrator) - these two never mix.
 */
export type WorkerRole = 'RN' | 'CNA' | 'LPN'

/**
 * The acronym is the label: RN, CNA and LPN are how these credentials are
 * written on a schedule, and the column is narrow. The full name goes in a
 * tooltip rather than the cell.
 */
export const WORKER_ROLE_LABELS: Record<WorkerRole, string> = {
  RN: 'Registered Nurse',
  CNA: 'Certified Nursing Assistant',
  LPN: 'Licensed Practical Nurse',
}

/**
 * Roles render in one neutral marine tint rather than a colour each.
 *
 * Colour in this dashboard already carries reliability meaning - tier is
 * gold/silver/bronze, and coral marks call-outs and other negatives. Giving
 * each role its own colour would put a second, unrelated scale in the same
 * row and invite reading a role as good or bad. The brand palette is also
 * deliberately small (marine, coral, white), with no third hue to spend
 * here.
 */
export const WORKER_ROLE_BADGE_CLASS = 'bg-marine-lt text-marine'
